import { AtlasDialogState } from "@resource/atlas";
import { useEffect } from "react";
import { UseFormReturn } from "react-hook-form";

type UseDialogStateFormManagementProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  useFormReturn: UseFormReturn<any>;
  dialogState: AtlasDialogState;
};

export function useDialogStateFormManagement({
  useFormReturn,
  dialogState,
}: UseDialogStateFormManagementProps) {
  /** Reset the form when dialog closes */
  useEffect(() => {
    if (!dialogState.open) {
      useFormReturn.reset();
    }
  }, [dialogState.open, useFormReturn]);
}
